import { ApiClient } from '../../../shared/api/ApiClient';

export interface ConsumableWeightBracket {
  id: string;
  settingsId: string;
  minWeightG: number;
  maxWeightG: number;
  priceMinorUnits: number;
}

export interface ShippingSettings {
  id: string;
  shopId: string;
  mode: 'manual' | 'tnt';
  freeShippingTags: string;
  freeServiceName: string;
  freeWeightThresholdG: number;
  consumableRateType: 'flat' | 'per_item' | 'weight';
  consumableServiceName: string;
  flatPriceMinorUnits: number;
  perItemBaseMinorUnits: number;
  perItemPriceMinorUnits: number;
  weightBrackets: ConsumableWeightBracket[];
}

export interface ShippingSettingsInput {
  shopDomain: string;
  mode?: 'manual' | 'tnt';
  freeShippingTags?: string;
  freeServiceName?: string;
  freeWeightThresholdG?: number;
  consumableRateType?: 'flat' | 'per_item' | 'weight';
  consumableServiceName?: string;
  flatPriceMinorUnits?: number;
  perItemBaseMinorUnits?: number;
  perItemPriceMinorUnits?: number;
}

export interface BracketInput {
  shopDomain: string;
  minWeightG: number;
  maxWeightG: number;
  priceMinorUnits: number;
}

export function getShippingSettings(
  api: ApiClient,
  shopDomain: string,
): Promise<ShippingSettings> {
  return api.get<ShippingSettings>(
    `/admin/api/shipping-settings?shopDomain=${encodeURIComponent(shopDomain)}`,
  );
}

export function updateShippingSettings(
  api: ApiClient,
  input: ShippingSettingsInput,
): Promise<ShippingSettings> {
  return api.put<ShippingSettings>('/admin/api/shipping-settings', input);
}

export function createBracket(
  api: ApiClient,
  input: BracketInput,
): Promise<ConsumableWeightBracket> {
  return api.post<ConsumableWeightBracket>('/admin/api/shipping-settings/brackets', input);
}

export function deleteBracket(api: ApiClient, id: string): Promise<void> {
  return api.delete<void>(`/admin/api/shipping-settings/brackets/${id}`);
}
